import React, {useState} from "react";
import styled from 'styled-components';
import {Button, FormControl, FormHelperText, FormLabel, Input, Stack, useToast} from "@chakra-ui/react";
import {useHistory} from "react-router-dom";
import {Footer, Fullscreen, Main} from '../../components/fullscreen_view';
import Form, {Legal} from "../../components/form";
import {useSignUp} from "../../api/sign_up";
import useFeedback from "../../utils/use_feedback";
import ErrorMessage from "../../components/error_message";
import {FixedTopBar} from "../../components/top_bar";
import NavLink from "../../components/nav_link";
import {useBaseCommunity, useStoreProfile} from "../../store";
import {useSheetModal} from "../../components/test/ModalContext";
import {themecolors} from "../../utils/themecolors";

const AlternateOption = styled.div``;

const Registration = styled(({className}) => {

    const { openModal } = useSheetModal();
    const history = useHistory();

    const {feedbackCh, error} = useFeedback(true);
    const signUp = useSignUp(feedbackCh);
    const toast = useToast();
    const [name, setName] = useState('');
    const [password, setPassword] = useState('')

    const handleUsername = (event) => setName(event.target.value)
    const handlePassword = (event) => setPassword(event.target.value)

    const [loading, setLoading] = useState(false);
    const {expand, subscribed, theme} = useStoreProfile();
    const ref = localStorage.getItem('referrer');
    const baseCommunity = useBaseCommunity().toLowerCase();
    const handleSignUp = async () => {

        setLoading(true);
        try {
            const data = {
                name,
                email: '',
                password,
                confirmPassword: password,
                com: window.origin,
                community: "Win",
                legal: true,
                expand: expand === 'card',
                theme,
                subscriptions: [],
                affRef: ref || "",
            };
            await signUp(data);
            /*if (baseCommunity !== "thedonald") {

                // open modal

                const modalContent = ({ handleCloseModal }) => (
                    <Sheet onClose={() => handleCloseModal() } padding={"header"} isMaxHeight><OnboardingSheet onClose={() => handleCloseModal() } /></Sheet>
                );

                openModal(modalContent);

            }*/
            location.replace('/');
        } catch (error) {
            toast({
                title: `Something isn't right...`,
                description: error.toString(),
                status: 'error',
                isClosable: true,
            });
        }
        setLoading(false);
    };

    return (
        <Fullscreen className={className}>
            <FixedTopBar back border={false} title="Create an Account" />
            <Main>
                <Form autocomplete="off">

                    <Stack spacing={5}>

                        <FormControl>
                            <FormLabel>Username</FormLabel>
                            <Input type="text"
                                   maxLength="24"
                                   autoComplete="off"
                                   required
                                   onChange={handleUsername}
                            />
                            <FormHelperText>This cannot be changed later.</FormHelperText>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Password</FormLabel>
                            <Input type="password"
                                   maxLength="64"
                                   autoComplete="off"
                                   placeholder={'********'}
                                   required
                                   onChange={handlePassword}
                            />
                            <FormHelperText>Password should be 8 characters or longer.</FormHelperText>
                        </FormControl>

                    </Stack>

                </Form>
            </Main>
            <Footer>
                <AlternateOption>
                    {`Already have an account? `}
                    <NavLink href={'/login'} replace>Log in.</NavLink>
                </AlternateOption>
                <Button variant={"blue"} width={"100%"} onClick={handleSignUp} isLoading={loading}>Sign Up</Button>
                <ErrorMessage error={error}/>
                <Legal>
                    By signing up, you agree to our
                    <a href={'https://help.scored.co/knowledge-base/terms-of-service/'}> Terms of Use</a>,
                    <a href={'https://help.scored.co/knowledge-base/privacy-policy/'}> Privacy Policy</a>, and
                    <a href={'https://help.scored.co/knowledge-base/content-policy/'}> Content Policy</a>.
                </Legal>
            </Footer>
        </Fullscreen>
    );
})`

  ${Form} {
    margin-top: 16px;
  }
  
  ${Footer} {
    width: calc(100% - 42px);
    margin: 0 auto;
  }

  ${Legal} {
    font-size: 13px;
    width: 280px;
    margin: 0 auto;
    margin-top: 12px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Legal} a {
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }

  ${AlternateOption} a {
    font-weight: 600;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }

  ${AlternateOption} {
    font-size: 15px;
    margin-bottom: 16px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
`;

export default Registration;
